import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from '@fiverr-private/fiverr_context';
import SocialAccount from '../shared/SocialAccount';
import WithImpressions from '../../../WithImpressions';
import { biHelper } from '../../biHelper';
import './style.scss';

export default function LinkedAccounts({ socialAccounts, biData }) {
    if (!socialAccounts.length) { return null; }

    const seller_card_about_me_linked_accounts_impression = biHelper({
        ...biData,
        group: 'seller_card_about_me_linked_accounts_impression',
        data: socialAccounts
    });

    return (
        <WithImpressions value={seller_card_about_me_linked_accounts_impression} className="linked-accounts">
            <h3><I18n k="user_page_perseus.seller_profile.linked_accounts"/></h3>
            <ul>
                {socialAccounts.map((platform, idx) =>
                    (<SocialAccount key={idx}
                        platformData={{ platform: platform.name }}/>))}
            </ul>
        </WithImpressions>
    );
}

LinkedAccounts.propTypes = {
    socialAccounts: PropTypes.array,
    biData: PropTypes.object
};

LinkedAccounts.defaultProps = {
    socialAccounts: [],
    biData: {}
};
